import { Suspense, lazy } from 'react';
import SuspenseLoader from './SuspenseLoader/index';
import SidebarLayout from './pages/global/sidebarLayout';
const Loader = (Component) => (props) => ( <Suspense fallback={<SuspenseLoader />}> <Component {...props} /> </Suspense> );
// ADMIN
const PaidExam = Loader(lazy(() => import('./pages/admin/Exam/PaidExam')));
const Reward = Loader(lazy(() => import('./pages/admin/Reward/Reward')));
const Withdraw = Loader(lazy(() => import('./pages/admin/Withdraw/WithdrawalList')));
const FreeExam = Loader(lazy(() => import('./pages/admin/Exam/FreeExam')));
const ManageUser = Loader(lazy(() => import('./pages/admin/User/UserList')));
const Report = Loader(lazy(() => import('./pages/admin/Reported/Report')));
const AdminDashboard = Loader(lazy(() => import('./pages/admin/Dashboard')));
const Category = Loader(lazy(() => import('./pages/admin/Category/Category')));
const AddQuestion = Loader(lazy(() => import('./pages/admin/Question/index')));
const ManageUserAccount = Loader(lazy(() => import('./pages/admin/User/userAccount/index')));
const ExamChallenge = Loader(lazy(() => import('./pages/admin/Exam/ExamChallenge')));
const ManageReport = Loader(lazy(() => import('./pages/admin/Reported/ManageReport')));
const Subscription = Loader(lazy(() => import('./pages/admin/Subscription/Subscription')));

//User
 const MainLayout = Loader(lazy(() => import('./pages/global/mainLayout')));
 const NavbarLayout = Loader(lazy(() => import('./pages/global/mainLayout/nav')));

const FAQ = Loader(lazy(() => import('./pages/home/FAQ')));
const Home = Loader(lazy(() => import('./pages/home/Home')));
const Help = Loader(lazy(() => import('./pages/home/Help/Help')));
const StartExam = Loader(lazy(() => import('./pages/exam/startExam')));
const ExamList = Loader(lazy(() => import('./pages/exam/FreeExamList')));
const ResultPage = Loader(lazy(() => import('./pages/exam/resultPage')));
const Login = Loader(lazy(() => import('./pages/auth/loginPages/index')));
const ContactUs = Loader(lazy(() => import('./pages/Contact/Contactus')));
const Register = Loader(lazy(() => import('./pages/auth/signupPages/index')));
const StartFreeExam = Loader(lazy(() => import('./pages/exam/StartFreeExam')));
const UserDashboard = Loader(lazy(() => import('./pages/exam/user/Dashboard')));
const UserAccount = Loader(lazy(() => import('./pages/exam/user/main/index')));
const UpdateSubscription = Loader(lazy(() => import('./pages/auth/Subscription')));
const ResetPassword = Loader(lazy(() => import('./pages/auth/resetPassword/index')));
const ForgotPassword = Loader(lazy(() => import('./pages/auth/forgotPassword/index')));
const Announcement = Loader(lazy(() => import('./pages/home/Announcement/Announcement')));
const ResultDetail = Loader(lazy(() => import('./pages/exam/user/Dashboard/ResultDetail')));
const PageNotFound = Loader(lazy(() => import('./pages/global/ErrorPage/404PageNotFound')));
const AdditionalSubscription = Loader(lazy(() => import('./pages/auth/Subscription/AdditionalSubscription')));

const routes =  [
  {
    path: '',
    element: <Home />
  },
  {
    path: 'admin/dashboard',
    element: <SidebarLayout />,
    children: [
      {
        path: 'main',
        element: <AdminDashboard />
      },
      {
        path: 'home',
        element: <Home />
      },
      {
        path: 'reward',
        element: <Reward />
      },
      {
        path: 'withdraw',
        element: <Withdraw />
      },
      {
        path: 'question',
        element: <AddQuestion />
      },
      {
        path: 'exam-challenge',
        element: <ExamChallenge /> 
      },
      {
        path: 'paid-exam',
        element: <PaidExam />
      },
      {
        path: 'free-exam',
        element: <FreeExam />
      },
      {
        path: 'user',
        element: <ManageUser />
      },
      {
        path: 'user/edit-user/:userId',
        element: <ManageUserAccount />
      },
      {
        path: 'category',
        element: <Category />
      },
      {
        path: 'subscription',
        element: <Subscription />
      },
      {
        path: 'report',
        element: <Report />
      },
      {
        path: 'report/manage/:reportId',
        element: <ManageReport />
      },
      {
        path: '',
        element: <PageNotFound />
      },
      {
        path: '*',
        element: <PageNotFound />
      }
      
    ]
  },
  {
    path: 'user',
    element: <MainLayout/>,
    children: [
      {
        path: 'dashboard',
        element: <UserDashboard/>
      },
      {
        path: 'result-summary',
        element: <ResultDetail />
      },
      {
        path: 'settings',
        element: <UserAccount />
      },
      {
        path: 'new/subscription',
        element: <AdditionalSubscription />
      },
      {
        path: '*',
        element: <PageNotFound />
      }
    ]
  },
  {
    path: 'exam',
    children: [
      {
        path: 'result',
        element: <ResultPage/>
      },
      {
        path: 'start',
        element: <StartExam/>
      },
      {
        path: 'free/start',
        element: <StartFreeExam/>
      },
      {
        path: 'free',
        element: <NavbarLayout isQuickLinkExcluded={false}/>,
        children: [
          {
            path: '',
            element: <ExamList/>
          },
          {
            path: '*',
            element: <PageNotFound />
          }
        ]
      },
      {
        path: '',
        element: <PageNotFound />
      },
      {
        path: '*',
        element: <PageNotFound />
      }
    ]
  },
  {
    path: '',
    element: <NavbarLayout/>,
    children: [
      {
        path: 'faq',
        element: <FAQ />
      },
      {
        path: 'contact',
        element: <ContactUs />
      }
      ,
      {
        path: 'help',
        element: <Help />
      },
      {
        path: 'announcement',
        element: <Announcement />
      }
    ]
  },
  {
    path: 'auth',
    element: <NavbarLayout/>,
    children: [
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'register',
        element: <Register />
      },
      {
        path: 'password/forgot-password',
        element: <ForgotPassword />
      },
      {
        path: 'password/reset-password/:resetToken',
        element: <ResetPassword />
      },
      {
        path: 'update/subscription/:categoryId',
        element: <UpdateSubscription />
      },
      {
        path: '',
        element: <PageNotFound />
      },
      {
        path: '*',
        element: <PageNotFound />
      }
    ]
  },
  {
    path: '',
    element: <NavbarLayout isQuickLinkExcluded={false}/>,
    children: [
     { 
      path: '*',
      element: <PageNotFound />
    }
    ]

  }
];
export default routes;
